import React from "react";
import "./DeliveryStatus.css"; // Optional for styling

const DeliveryStatus = ({ status = "pending" }) => {
  const statusOrder = ["pending", "approved", "confirmed", "served"];
  const arabicStatus = {
    pending: "في إنتظار تأكيد العميد",
    approved: "تمت  موافقة العميد",
    confirmed: "تم  تأكيد التسليم ",
    served: "تم تأكيد الاستلام",
    rejected: "تم الرفض",
  };

  const currentIndex = statusOrder.indexOf(status);

  if (status === "rejected") {
    return (
      <div className="rejected-message">
        <p>{arabicStatus.rejected}</p>
      </div>
    );
  }

  return (
    <div className="delivery-status">
      <div className="status-line">
        {statusOrder.map((step, index) => (
          <div
            key={step}
            className={`status-point ${index <= currentIndex ? "active" : ""}`}
          >
            <span>{arabicStatus[step]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeliveryStatus;
